import { FileType } from '../../ui/file.model';
import { FileTypeResource } from '../../resource/file-type.resource';

export const FileTypeToFileTypeResourceMap = new Map<FileType, FileTypeResource>([
	['original-file', 1],
	['extracted-html-file', 2],
	['incoming-production-image', 3],
	['incoming-production-text', 4],
	['normalized-tiff', 5],
	['normalized-pdf', 6],
	['normalized-translated-file', 7],
	['redaction-image', 8],
	['redacted-pdf', 9],
	['annotation-image', 10],
	['annotated-pdf', 11],
	['transcribed-file', 12],
	['image-label-file', 13],
	['entity-analysis-file', 14],
	['incoming-production-pdf', 15],
	['outgoing-production-image', 20],
	['outgoing-production-bates-stamped-pdf', 21],
	['outgoing-production-text', 22],
	['outgoing-production-loadfile-lexbe', 23],
	['outgoing-production-loadfile-summation', 24],
	['outgoing-production-loadfile-piped-separated-values', 25],
	['outgoing-production-loadfile-concordance', 26],
	['outgoing-production-image-load-file', 27],
	['outgoing-production-loadfile-tab-separated-values', 28],
	['outgoing-production-placeholder-original', 29],
	['outgoing-production-withheld-log',50],
	['legacy-download-zip', 30],
	['outgoing-briefcase-bates-stamped-pdf', 31],
	['outgoing-briefcase-redacted-pdf', 32],
	['outgoing-briefcase-pdf-merged', 33],
	['outgoing-briefcase-redacted-merged', 34],
	['outgoing-briefcase-annotated-pdf', 35],
	['outgoing-briefcase-annotated-merged', 36],
	['outgoing-briefcase-zipped', 37],
	['archive-image', 40],
	['archive-text', 41],
	['archive-job-loadfile-lexbe', 43],
	['archive-job-loadfile-summation', 44],
	['archive-job-loadfile-piped-separated-values', 45],
	['archive-job-loadfile-concordance', 46],
	['archive-job-image-log-file', 47],
	['archive-job-loadfile-tab-separated-values', 48]
]);
